export default "<p>\n  location-field works!\n</p>\n"